import { ElMessage } from "element-plus";

export default defineNuxtPlugin((nuxtApp) => {
  // 注册 Element Plus 的 message 组件到全局
  nuxtApp.vueApp.config.globalProperties.$message = ElMessage;
});
